import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/40bf00b9-f18c-44d8-a676-5130a937a547";
export const REGISTER_URL = "https://a.ntrk2.com/baabebae-38db-44b7-8157-dd96d1ea8c60";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ezgana.kzw2a.com/download?openExternalBrowser=1&id=j3mccku0a8jm8xj";

export * from "./codes";
export * from "./context";
